import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Text from '../Text';

const ALIGNMENTS = {
  left: 'left-0',
  center: 'right-1/2 translate-x-1/2 text-center',
  right: 'right-0',
};

const DIRECTIONS = {
  bottom: 'top-[calc(100%_+_0.25rem)]',
  top: 'bottom-[calc(100%_+_0.25rem)]',
};

function TooltipBox({
  align = 'center',
  autoClose = true,
  bold = false,
  children,
  className,
  direction = 'bottom',
  size = 'size3',
}) {
  return (
    <div
      className={twMerge(
        'absolute z-2 cursor-default select-none rounded-2 bg-neutral-low-100 p-2 peer-hover:block dark:bg-neutral-high-200',
        autoClose && 'hidden focus-within:block parent-hover:block',
        ALIGNMENTS[align],
        DIRECTIONS[direction],
        className
      )}
      role="tooltip"
    >
      <Text
        as="span"
        bold={bold}
        className="text-neutral-high-100 dark:text-neutral-low-300"
        size={size}
      >
        {children}
      </Text>
    </div>
  );
}

TooltipBox.propTypes = {
  /**
   * Choose the way that Tooltip must aligned from children
   */
  align: PropTypes.oneOf(['left', 'center', 'right']),
  /**
   * Choose behavior of Tooltip. Default is to be showed when trigger is
   * focused of hovered
   */
  autoClose: PropTypes.bool,
  /**
   * Renders a bold text
   */
  bold: PropTypes.bool,
  /**
   * Text thats should be showed when trigger is focused of hovered
   */
  children: PropTypes.node.isRequired,
  /**
   * Relative direction for positioning purposes
   */
  direction: PropTypes.oneOf(['bottom', 'top']),
  /**
   * Renders Tooltip with one of the pre-determined size
   */
  size: PropTypes.oneOf(['size1', 'size2', 'size3']),
};

export default TooltipBox;
